import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Summary_Scaleless_2({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  return (
    //item.name = Hayal Gücü, item.scopeName = Açıklık
    <Row className={"mb-3 mx-0"}>
      <div className="summary-scaleless-container-wrap-up">
        <Row className={"justify-content-center"}>
          <Col
            xs={"auto"}
            className={`pt-0 text-end align-content-center   ${isSub ? "detail-section-sub-scope-name-header-wrap-up" : "detail-section-scope-name-header-wrap-up"}`}
          >
            {item.name}
          </Col>
          <Col xs={"auto"}>
            <div className={isSub ? "detail-sub-scope-score-header-wrap-up" : "detail-main-scope-score-header-wrap-up"}>
              {elementScore}
            </div>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
